import { c as _c } from "react/compiler-runtime";
// Tremor Raw ProgressCircle [v0.0.0]
import { VariantProps } from "tailwind-variants";
import React from "react";
import { tv } from "@/lib/tailwind-utils";
import { cx } from "@/lib/tailwind-utils";
const progressCircleVariants = tv({
  slots: {
    background: "",
    circle: ""
  },
  variants: {
    variant: {
      default: {
        background: "stroke-accent-200",
        circle: "stroke-primary"
      },
      neutral: {
        background: "stroke-gray-200",
        circle: "stroke-gray-500"
      },
      warning: {
        background: "stroke-yellow-200",
        circle: "stroke-yellow-500"
      },
      error: {
        background: "stroke-red-200",
        circle: "stroke-red-500"
      },
      success: {
        background: "stroke-emerald-200",
        circle: "stroke-emerald-500"
      }
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
interface ProgressCircleProps extends Omit<React.SVGProps<SVGSVGElement>, "value">, VariantProps<typeof progressCircleVariants> {
  value?: number;
  max?: number;
  showAnimation?: boolean;
  radius?: number;
  strokeWidth?: number;
  children?: React.ReactNode;
}
const ProgressCircle = React.forwardRef<SVGSVGElement, ProgressCircleProps>((t0, forwardedRef) => {
  const $ = _c(65);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let variant;
  if ($[0] !== t0) {
    ({
      value: t1,
      max: t2,
      radius: t3,
      strokeWidth: t4,
      showAnimation: t5,
      variant,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    variant = $[9];
  }
  const value = t1 === undefined ? 0 : t1;
  const max = t2 === undefined ? 100 : t2;
  const radius = t3 === undefined ? 32 : t3;
  const strokeWidth = t4 === undefined ? 6 : t4;
  const showAnimation = t5 === undefined ? true : t5;
  const safeValue = Math.min(max, Math.max(value, 0));
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const offset = circumference - safeValue / max * circumference;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[10] !== circumference || $[11] !== className || $[12] !== forwardedRef || $[13] !== max || $[14] !== normalizedRadius || $[15] !== offset || $[16] !== props || $[17] !== radius || $[18] !== safeValue || $[19] !== showAnimation || $[20] !== strokeWidth || $[21] !== value || $[22] !== variant) {
    const {
      background,
      circle
    } = progressCircleVariants({
      variant
    });
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = cx("relative");
      $[39] = t21;
    } else {
      t21 = $[39];
    }
    t6 = forwardedRef;
    t7 = radius * 2;
    t8 = radius * 2;
    t9 = `0 0 ${radius * 2} ${radius * 2}`;
    if ($[40] !== className) {
      t10 = cx("-rotate-90 transform", className);
      $[40] = className;
      $[41] = t10;
    } else {
      t10 = $[41];
    }
    t11 = "progress circle";
    t12 = "progress bar";
    t13 = value;
    t14 = 0;
    t15 = max;
    t16 = max;
    t17 = safeValue ?? null;
    t18 = props;
    t19 = <circle r={normalizedRadius} cx={radius} cy={radius} strokeWidth={strokeWidth} fill="transparent" stroke="" strokeLinecap="round" className={cx("transition-colors ease-linear", background())} />;
    t20 = safeValue >= 0 ? <circle r={normalizedRadius} cx={radius} cy={radius} strokeWidth={strokeWidth} strokeDasharray={`${circumference} ${circumference}`} strokeDashoffset={offset} fill="transparent" stroke="" strokeLinecap="round" className={cx("transition-colors ease-linear", circle(), showAnimation && "transition-all duration-300 ease-in-out")} /> : null;
    $[10] = circumference;
    $[11] = className;
    $[12] = forwardedRef;
    $[13] = max;
    $[14] = normalizedRadius;
    $[15] = offset;
    $[16] = props;
    $[17] = radius;
    $[18] = safeValue;
    $[19] = showAnimation;
    $[20] = strokeWidth;
    $[21] = value;
    $[22] = variant;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
    $[34] = t21;
    $[35] = t6;
    $[36] = t7;
    $[37] = t8;
    $[38] = t9;
  } else {
    t10 = $[23];
    t11 = $[24];
    t12 = $[25];
    t13 = $[26];
    t14 = $[27];
    t15 = $[28];
    t16 = $[29];
    t17 = $[30];
    t18 = $[31];
    t19 = $[32];
    t20 = $[33];
    t21 = $[34];
    t6 = $[35];
    t7 = $[36];
    t8 = $[37];
    t9 = $[38];
  }
  let t22;
  if ($[42] !== t10 || $[43] !== t11 || $[44] !== t12 || $[45] !== t13 || $[46] !== t14 || $[47] !== t15 || $[48] !== t16 || $[49] !== t17 || $[50] !== t18 || $[51] !== t19 || $[52] !== t20 || $[53] !== t6 || $[54] !== t7 || $[55] !== t8 || $[56] !== t9) {
    t22 = <svg ref={t6} width={t7} height={t8} viewBox={t9} className={t10} role={t11} aria-label={t12} aria-valuenow={t13} aria-valuemin={t14} aria-valuemax={t15} data-max={t16} data-value={t17} {...t18}>{t19}{t20}</svg>;
    $[42] = t10;
    $[43] = t11;
    $[44] = t12;
    $[45] = t13;
    $[46] = t14;
    $[47] = t15;
    $[48] = t16;
    $[49] = t17;
    $[50] = t18;
    $[51] = t19;
    $[52] = t20;
    $[53] = t6;
    $[54] = t7;
    $[55] = t8;
    $[56] = t9;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = cx("absolute inset-0 flex items-center justify-center");
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== children) {
    t24 = <div className={t23}>{children}</div>;
    $[59] = children;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== t21 || $[62] !== t22 || $[63] !== t24) {
    t25 = <><div className={t21}>{t22}{t24}</div></>;
    $[61] = t21;
    $[62] = t22;
    $[63] = t24;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  return t25;
});
ProgressCircle.displayName = "ProgressCircle";
export default ProgressCircle;
export { type ProgressCircleProps };